/** This file contains the constants for the navigation paths in the application. */

/** Constant for `pages/Login/index.tsx` component */
export const LOGIN = '/login'

/** Constant for `pages/ForgotPassword/index.tsx` component */
export const FORGOT_PASSWORD = '/forgot-password'

/** Constant for `pages/UserManual/index.tsx` component */
export const USER_MANUAL = '/manual'

/** Constant for `pages/XRayManual/index.tsx` component - X-Ray AI Analysis Manual */
export const XRAY_MANUAL = '/manual/xray'

/** Constant for `pages/Home/index.tsx` component */
export const HOME = ''

/** Constant for `pages/Patient/index.tsx` component */
export const PATIENT_LIST = 'patients'

/** Constant for `pages/Patient/AddPatient/index.tsx` component */
export const ADD_PATIENT = 'patients/add-patient'

/** Constant for `pages/Profile/index.tsx` component */
export const PROFILE = 'profile'

/** Constant for `pages/Patient/HealthData/index.tsx` component */
export const PATIENT_HEALTH_DATA = (patientId?: string) =>
  `patients/${patientId ?? ':patientId'}/health`

/** Constant for `pages/Patient/HealthDataDetail/index.tsx` component */
export const PATIENT_HEALTH_DATA_DETAIL = (patientId?: string, data?: string) =>
  `${PATIENT_HEALTH_DATA(patientId)}/${data ?? ':data'}/detail`

/** Constant for `pages/XRayProcess/index.tsx` component */
export const XRAY_PROCESS = 'x-ray-process'

/** Constant for `pages/Chat/index.tsx` component */
export const CHAT = 'chats'

/** Constant for `pages/MedicalInformation/index.tsx` component */
export const MEDICAL_INFO = 'informations'

/** Constant for specific `pages/Chat/index.tsx` component */
export const CHAT_ID = (chatId?: string) => `${chatId ?? ':chatId'}`

/** Constant for `pages/Chat/index.tsx` component */
export const CHAT_PATIENT = (chatId?: string) => `${CHAT}/${CHAT_ID(chatId)}`

/** Constant for `pages/Professional/index.tsx` component */
export const PROFESSIONALS = 'professional'

/** Constant for `pages/Professional/AddProfessional/index.tsx` component */
export const ADD_PROFESSIONALS = `${PROFESSIONALS}/add`

/** Constant for `pages/Professional/EditProfessional/index.tsx` component */
export const EDIT_PROFESSIONALS = (userId?: string) =>
  `${PROFESSIONALS}/${userId ?? ':userId'}/edit`

/** Constant for `pages/Establishment/index.tsx` component */
export const ESTABLISHMENTS = 'establishments'

/** Constant for `pages/Establishment/AddEstablishment/index.tsx` component */
export const ADD_ESTABLISHMENT = `${ESTABLISHMENTS}/add`

/** Constant for `pages/Establishment/EditEstablishment/index.tsx` component */
export const EDIT_ESTABLISHMENT = (establishmentId?: string) =>
  `${ESTABLISHMENTS}/${establishmentId ?? ':establishmentId'}/edit`

/** Constant for `pages/FAQ/index.tsx` component */
export const FAQ = 'faq'

/** Constant for `pages/Recovery/index.tsx` component */
export const RECOVERY = 'recovery'

/** Constant for `pages/LegalInformation/index.tsx` component */
export const LEGAL_INFORMATION = 'legal-information'

/** Constant for `pages/MedicalEvents/index.tsx` component */
export const MEDICAL_EVENTS = 'medical-events'

/** Constant for `pages/MedicalEvents/Actions/index.tsx` component */
export const ADD_MEDICAL_EVENT = `${MEDICAL_EVENTS}/add`

/** Constant for `pages/MedicalEvents/Actions/index.tsx` component */
export const EDIT_MEDICAL_EVENT = (medicalEventId?: string) =>
  `${MEDICAL_EVENTS}/${medicalEventId ?? ':medicalEventId'}/edit`

/** Constant for `pages/PatientMedicalEvents/index.tsx` component */
export const PATIENT_MEDICAL_EVENTS = (patientId?: string) =>
  `${PATIENT_HEALTH_DATA(patientId)}/medical-events`

/** Constant for `pages/MedicalEvents/Actions/index.tsx` component */
export const ADD_PATIENT_MEDICAL_EVENT = (patientId?: string) =>
  `${PATIENT_MEDICAL_EVENTS(patientId)}/add`

/** Constant for `pages/MedicalEvents/Actions/index.tsx` component */
export const EDIT_PATIENT_MEDICAL_EVENT = (
  patientId?: string,
  medicalEventId?: string
) =>
  `${PATIENT_MEDICAL_EVENTS(patientId)}/${medicalEventId ?? ':medicalEventId'}/edit`

/** Base path para as telas de análises (agrupa Raio-X e ECG) */
export const DIAGNOSTICS = 'diagnostics'

/** Constant for `pages/Diagnostics/Cxray/index.tsx` component - listagem de Raio-X */
export const CXRAY_ANALYSIS = `${DIAGNOSTICS}/cxray`

/** Constant for `pages/Diagnostics/Ecg/index.tsx` component - listagem de ECG */
export const ECG_ANALYSIS = `${DIAGNOSTICS}/ecg`

/** Constant for `pages/Diagnostics/Upload/index.tsx` component */
export const DIAGNOSTICS_UPLOAD = 'upload'

/** Constant for `pages/Diagnostics/Detail/index.tsx` component */
export const DIAGNOSTICS_DETAIL = (diagnosticId?: string) =>
  `${diagnosticId ?? ':diagnosticId'}/detail`

/** Constant for `pages/Diagnostics/Detail/PrintView.tsx` component */
export const DIAGNOSTICS_PRINT = (diagnosticId?: string) =>
  `${DIAGNOSTICS}/${diagnosticId ?? ':diagnosticId'}/print`

/** Constant for `pages/SymptomTracking/index.tsx` component */
export const SYMPTOM_TRACKING = 'symptom-tracking'
